<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Veículo - Motorista | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_veiculo_fabricante">Fabricante <sup class="text-danger">* </sup></label>
              <select id="cd_veiculo_fabricante" v-model="registro.cd_veiculo_fabricante" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_veiculo_fabricante }">
                <option v-for="item in fabricantes" v-bind:key="item.cd_fabricante" v-bind:value="item.cd_fabricante">{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_veiculo_fabricante != null" class="help-inline">{{ errors.cd_veiculo_fabricante }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="veiculo_modelo">Modelo <sup class="text-danger">* </sup></label>
              <input id="veiculo_modelo" v-model="registro.veiculo_modelo" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.veiculo_modelo }">
              <span v-show="errors.veiculo_modelo != null" class="help-inline">{{ errors.veiculo_modelo }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="veiculo_ano">Ano <sup class="text-danger">* </sup></label>
              <input id="veiculo_ano" v-model="registro.veiculo_ano" v-mask="'####'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.veiculo_ano }">
              <span v-show="errors.veiculo_ano != null" class="help-inline">{{ errors.veiculo_ano }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="veiculo_placa">Placa <sup class="text-danger">* </sup></label>
              <input id="veiculo_placa" v-model="registro.veiculo_placa" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.veiculo_placa }">
              <span v-show="errors.veiculo_placa != null" class="help-inline">{{ errors.veiculo_placa }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="encosto_cabeca">Encosto de cabeça <sup class="text-danger">* </sup></label>
              <select id="encosto_cabeca" v-model="registro.encosto_cabeca" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.encosto_cabeca }">
                <option v-for="item in tipoEncostoCabeca" v-bind:key="item.id" v-bind:value="item.id">{{ item.desc }}</option>
              </select>
              <span v-show="errors.encosto_cabeca != null" class="help-inline">{{ errors.encosto_cabeca }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_motorista_kovi">Motorista Kovi <sup class="text-danger">* </sup></label>
              <select id="idc_motorista_kovi" v-model="registro.idc_motorista_kovi" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_motorista_kovi }">
                <option v-for="item in tipoMotoristaKovi" v-bind:key="item.id" v-bind:value="item.id">{{ item.desc }}</option>
              </select>
              <span v-show="errors.idc_motorista_kovi != null" class="help-inline">{{ errors.idc_motorista_kovi }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_veiculo_proprio">Veículo próprio <sup class="text-danger">* </sup></label>
              <select id="idc_veiculo_proprio" v-model="registro.idc_veiculo_proprio" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_veiculo_proprio }">
                <option v-for="item in tipoVeiculoProprio" v-bind:key="item.id" v-bind:value="item.id">{{ item.desc }}</option>
              </select>
              <span v-show="errors.idc_veiculo_proprio != null" class="help-inline">{{ errors.idc_veiculo_proprio }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="posse_veiculo">Posse do veículo <sup class="text-danger">* </sup></label>
              <select id="posse_veiculo" v-model="registro.posse_veiculo" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.posse_veiculo }">
                <option v-for="item in tipoPosseVeiculo" v-bind:key="item.id" v-bind:value="item.id">{{ item.desc }}</option>
              </select>
              <span v-show="errors.posse_veiculo != null" class="help-inline">{{ errors.posse_veiculo }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MotoristaActions from '../../actions/MotoristaActions'
import VeiculoActions from '../../actions/VeiculoActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      exists: true,
      registro: {
        cd_veiculo_fabricante: '',
        cd_motorista: '',
        veiculo_modelo: '',
        veiculo_ano: '',
        veiculo_placa: '',
        encosto_cabeca: '',
        idc_motorista_kovi: '',
        idc_veiculo_proprio: '',
        posse_veiculo: ''
      },
      fabricantes: [],
      tipoEncostoCabeca: [
        { id: 1, desc: 'Tradicional / Regulavel' },
        { id: 2, desc: 'Inteiriço / Fixo' }
      ],
      tipoMotoristaKovi: [
        { id: '', desc: 'Não informado' },
        { id: true, desc: 'Sim' },
        { id: false, desc: 'Não' }
      ],
      tipoVeiculoProprio: [
        { id: '', desc: 'Não informado' },
        { id: 1, desc: 'Veículo próprio' },
        { id: 2, desc: 'Veículo alugado' }
      ],
      tipoPosseVeiculo: [
        { id: '', desc: 'Não informado' },
        { id: 1, desc: 'Veículo próprio' },
        { id: 2, desc: 'Alugado por outra(s) locadora(s)' }
      ]
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'
    this.$parent.$parent.$data.showModalLoader = true

    this.listarFabricantes()

    MotoristaActions.obterMotoristaComplemento(this.id)
      .then(res => {
        if (res && res.cd_veiculo_fabricante) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }

        this.$parent.$parent.$data.showModalLoader = false
      })
      .catch((error) => {
        if (!error.response.status === 404) {
          this.errorMessage = 'Registro não encontrado.'
          this.exists = true
        } else {
          this.exists = false
        }

        this.$parent.$parent.$data.showModalLoader = false
      })
  },
  methods: {
    voltar () {
      this.$router.push({ path: `/motoristas/${this.id}`, query: { ret_url: this.$route.query.ret_url } })
    },
    listarFabricantes () {
      VeiculoActions.listarFabricantes()
        .then(res => {
          this.fabricantes = res
        })
    },
    create () {
      MotoristaActions
        .inserirMotoristaComplemento({
          cd_motorista: this.id,
          cd_veiculo_fabricante: this.registro.cd_veiculo_fabricante,
          veiculo_modelo: this.registro.veiculo_modelo,
          veiculo_ano: this.registro.veiculo_ano,
          veiculo_placa: this.registro.veiculo_placa,
          encosto_cabeca: this.registro.encosto_cabeca,
          idc_motorista_kovi: this.registro.idc_motorista_kovi,
          idc_veiculo_proprio: this.registro.idc_veiculo_proprio,
          posse_veiculo: this.registro.posse_veiculo
        })
        .then(() => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push({ path: '/motoristas/' + this.id, query: { ret_url: this.$route.query.ret_url } })
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    update () {
      MotoristaActions
        .alterarMotoristaComplemento({
          id: this.id,
          cd_veiculo_fabricante: this.registro.cd_veiculo_fabricante,
          veiculo_modelo: this.registro.veiculo_modelo,
          veiculo_ano: this.registro.veiculo_ano,
          veiculo_placa: this.registro.veiculo_placa,
          encosto_cabeca: this.registro.encosto_cabeca,
          idc_motorista_kovi: this.registro.idc_motorista_kovi,
          idc_veiculo_proprio: this.registro.idc_veiculo_proprio,
          posse_veiculo: this.registro.posse_veiculo
        })
        .then(() => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push({ path: '/motoristas/' + this.id, query: { ret_url: this.$route.query.ret_url } })
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_veiculo_fabricante) {
        this.errors.cd_veiculo_fabricante = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.veiculo_modelo) {
        this.errors.veiculo_modelo = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.veiculo_ano) {
        this.errors.veiculo_ano = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.veiculo_placa) {
        this.errors.veiculo_placa = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.encosto_cabeca) {
        this.errors.encosto_cabeca = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        if (this.exists) {
          this.update()
        } else {
          this.create()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/motorista/EditarComplemento.vue